/* @generated */

// ../src/keycap/keycap.tsx
import * as React2 from "react";
import cls from "classnames";

// ../src/keycap/keycap.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var cookKeycapFrameRecipe = _7a468({ defaultClassName: "dig-10r01231_22-5-0", variantClassNames: { size: { small: "dig-10r01232_22-5-0", medium: "dig-10r01233_22-5-0", large: "dig-10r01234_22-5-0", xlarge: "dig-10r01235_22-5-0" }, variant: { filled: "dig-10r01236_22-5-0", outline: "dig-10r01237_22-5-0", opacity: "dig-10r01238_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var cookKeycapKeyRecipe = _7a468({ defaultClassName: "dig-10r01239_22-5-0", variantClassNames: { size: { small: "dig-10r0123a_22-5-0", medium: "dig-10r0123b_22-5-0", large: "dig-10r0123c_22-5-0", xlarge: "dig-10r0123d_22-5-0" }, shouldUseCurrentColor: { true: "dig-10r0123e_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var keycapComboStyle = "dig-10r0123h_22-5-0";
var keycapFaceBaselineAlignmentStyle = "dig-10r0123f_22-5-0";
var notSelectableStyle = "dig-10r0123g_22-5-0";

// ../src/keycap/display-and-describe.tsx
import * as React from "react";
import { visuallyHiddenClassName } from "@dropbox/dig-foundations";

// ../src/keycap/test-ids.ts
var TestIds = {
  KeycapFace: "digKeycapFace",
  KeycapGroupAccessibleLabel: "digKeycapGroupAccessibleLabel",
  DisplayAndDescribeDisplay: "digDisplayAndDescribeDisplay",
  DisplayAndDescribeDescribe: "digDisplayAndDescribeDescribe"
};

// ../src/keycap/display-and-describe.tsx
var getContentTag = (permittedContentType) => {
  let Tag;
  switch (permittedContentType) {
    case "phrasing":
      Tag = "span";
      break;
    case "flow":
      Tag = "div";
      break;
  }
  return Tag;
};
var DisplayAndDescribe = ({
  permittedContentType,
  display,
  describe,
  className
}) => {
  const Tag = getContentTag(permittedContentType);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, { "aria-hidden": true, className, "data-testid": TestIds.DisplayAndDescribeDisplay }, display), /* @__PURE__ */ React.createElement(
    Tag,
    {
      "data-testid": TestIds.DisplayAndDescribeDescribe,
      className: `${visuallyHiddenClassName} ${notSelectableStyle}`
    },
    describe
  ));
};
DisplayAndDescribe.displayName = "DisplayAndDescribe";

// ../src/keycap/keycap.tsx
import { atoms, Cluster } from "@dropbox/dig-foundations";

// ../src/keycap/data-attributes.ts
var keycapDataAttribute = "data-dig-keycap";
var keycapDataSizeAttributes = {
  small: `${keycapDataAttribute}-small`,
  medium: `${keycapDataAttribute}-medium`,
  large: `${keycapDataAttribute}-large`,
  xlarge: `${keycapDataAttribute}-xlarge`
};
function getKeycapDataAttributeProps(size) {
  return {
    [keycapDataSizeAttributes[size]]: ""
  };
}

// ../src/keycap/keycap.tsx
var availableSymbols = {
  shift: "\u21E7",
  return: "\u23CE",
  command: "\u2318",
  option: "\u2325",
  delete: "\u232B",
  tab: "\u2B72",
  escape: "\u238B",
  arrowDown: "\u2B63",
  arrowLeft: "\u2B60",
  arrowRight: "\u2B62",
  arrowUp: "\u2B61",
  control: "\u2303",
  apple: "\uF8FF",
  windows: "\u229E"
};
function isAccessible(props) {
  const { withAccessibleLabel, role } = props;
  return typeof withAccessibleLabel !== "undefined" && role !== "presentation";
}
var Keycap = (props) => {
  const {
    size = "medium",
    contentsAlignY = "center",
    variant,
    symbol: _symbol,
    withPrefix = null,
    withSuffix = null,
    display = "inline-flex",
    className,
    // Unused because we're using type guards to pull the label out
    withAccessibleLabel: _,
    // Ignored and ripped out to avoid missetting
    ["aria-hidden"]: _2,
    ...rest
  } = props;
  const contents = [withPrefix];
  const symbol = _symbol in availableSymbols ? availableSymbols[_symbol] : _symbol;
  contents.push(symbol);
  contents.push(withSuffix);
  const isComponentAccessible2 = isAccessible(props);
  const shouldUseBaselineAlignment = contentsAlignY !== "baseline";
  const alignY = shouldUseBaselineAlignment ? contentsAlignY : void 0;
  const displayedContents = /* @__PURE__ */ React2.createElement(
    Cluster,
    {
      isFlexGap: true,
      gap: "Micro Small",
      alignY,
      className: cls({
        // Override for the Cluster to apply baseline alignment because
        // the Cluster does not provide it - and probably shouldn't
        [keycapFaceBaselineAlignmentStyle]: shouldUseBaselineAlignment
      })
    },
    contents.filter((content) => typeof content !== "undefined" && content !== null).map((content, index) => /* @__PURE__ */ React2.createElement(Cluster.Item, { key: index }, content))
  );
  return /* @__PURE__ */ React2.createElement(
    "kbd",
    {
      ...rest,
      ...getKeycapDataAttributeProps(size),
      className: cls(
        cookKeycapFrameRecipe({ size, variant }),
        { [atoms({ display })]: display !== "inline-flex" },
        className
      ),
      role: isComponentAccessible2 ? void 0 : "presentation"
    },
    /* @__PURE__ */ React2.createElement(
      "span",
      {
        className: cookKeycapKeyRecipe({
          size,
          shouldUseCurrentColor: variant === "opacity" || variant === "outline"
        }),
        "data-testid": TestIds.KeycapFace
      },
      isComponentAccessible2 ? /* @__PURE__ */ React2.createElement(
        DisplayAndDescribe,
        {
          permittedContentType: "phrasing",
          display: displayedContents,
          describe: props.withAccessibleLabel
        }
      ) : displayedContents
    )
  );
};
Keycap.displayName = "Keycap";

// ../src/keycap/group.tsx
import * as React3 from "react";
import cls2 from "classnames";
import { atoms as atoms2, visuallyHiddenClassName as visuallyHiddenClassName2 } from "@dropbox/dig-foundations";
function isComponentAccessible(partialProps, role) {
  const label = "withAccessibleLabel" in partialProps && partialProps.withAccessibleLabel || void 0;
  return typeof label === "string" && role !== "presentation";
}
var KeycapGroup = ({
  keycaps,
  role,
  variant,
  display = "inline",
  size = "medium",
  withAccessibleAdjacentLabel,
  className,
  ...rest
}) => {
  const isGroupAccessible = role !== "presentation";
  return /* @__PURE__ */ React3.createElement(
    "kbd",
    {
      ...rest,
      className: cls2(keycapComboStyle, atoms2({ display }), className),
      role: isGroupAccessible ? void 0 : "presentation"
    },
    keycaps.map((props, index) => {
      const keycapProps = isComponentAccessible(props, role) ? {
        ...props,
        size,
        variant
      } : {
        ...props,
        size,
        variant,
        role: "presentation"
      };
      const shouldRenderAccessibleAdjacentLabel = index + 1 < keycaps.length;
      return /* @__PURE__ */ React3.createElement(React3.Fragment, { key: `keycap-group-${index}` }, /* @__PURE__ */ React3.createElement(Keycap, { ...keycapProps }), shouldRenderAccessibleAdjacentLabel ? /* @__PURE__ */ React3.createElement(
        "span",
        {
          className: cls2(visuallyHiddenClassName2, notSelectableStyle),
          "data-testid": TestIds.KeycapGroupAccessibleLabel
        },
        withAccessibleAdjacentLabel
      ) : null);
    })
  );
};
KeycapGroup.displayName = "KeycapGroup";

// ../src/keycap/index.ts
var KeycapNamespace = Object.assign(Keycap, {
  Group: KeycapGroup
});
export {
  KeycapNamespace as Keycap,
  TestIds
};
